import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages, FormattedMessage } from 'react-intl';
import FormattedCurrency from '../../../../../../components/formatted-currency/container';
import { RoleBasedNavLink } from '../../../../../../role-based-navlink';
import { UserPermissionService } from '../../../../../../services/user-permission-service';

// Constants functions a pseduo-error codes
const MINIMUM_FUNDING_ERROR = 'Minimum amount to that can be funded';
// SPD-9694: Remove this
const MISSING_BILLING_INFO_ERROR_OLD = 'Unable to find billing information';
const MISSING_BILLING_INFO_ERROR = 'No billing';
const INVALID_CURRENCY_ERROR = 'Insurance is only available in USD.';

const messages = defineMessages({
  minimumFundingError: {
    description: 'Add funds minimum funding error',
    defaultMessage: 'Minimum funding amount is {currency}',
    id: 'TE4GUH',
  },
  missingBillingInfoError: {
    description: 'Add Funds missing billing information',
    defaultMessage: '<a>Please add billing information to purchase insurance.</a>',
    id: 'Jssfci',
  },
  invalidCurrencyError: {
    description: 'Add funds invalid currency error',
    defaultMessage: 'Insurance is only available in USD.',
    id: 'jCceQV',
  },
  unknownErrorWithoutMessage: {
    description: 'Unknown error without message from server',
    defaultMessage: 'An unknown error occurred.',
    id: 'CId2Ig',
  },
});

const getUIErrorMessage = (errorResponse, minimumFundingAmount) => {
  if (!errorResponse?.Message) {
    return messages.unknownErrorWithoutMessage;
  }

  if (errorResponse.Message.startsWith(MINIMUM_FUNDING_ERROR)) {
    return {
      ...messages.minimumFundingError,
      values: {
        currency: <FormattedCurrency currencyCode={minimumFundingAmount?.code} value={minimumFundingAmount?.value} />,
      },
    };
  }

  if (errorResponse.Message.startsWith(MISSING_BILLING_INFO_ERROR) || errorResponse.Message.startsWith(MISSING_BILLING_INFO_ERROR_OLD)) {
    return {
      ...messages.missingBillingInfoError,
      values: {
        a: (chunks) => (
          <RoleBasedNavLink requiredPermissionRole={UserPermissionService.administrationPermissionRole} to='/settings/payments'>
            {chunks}
          </RoleBasedNavLink>
        ),
      },
    };
  }

  if (errorResponse.Message.startsWith(INVALID_CURRENCY_ERROR)) {
    // NOTE: Shipsurance is only available in USD. Will need to change once we support multiple insurance providers
    return messages.invalidCurrencyError;
  }

  return errorResponse.Message;
};

const AddFundErrorMessage = ({ error, minimumFundingAmount }) => {
  const messageDescriptor = getUIErrorMessage(error, minimumFundingAmount);

  return (
    <>
      <li>{typeof messageDescriptor === 'string' ? messageDescriptor : <FormattedMessage {...messageDescriptor} />}</li>
    </>
  );
};

AddFundErrorMessage.propTypes = {
  error: PropTypes.object.isRequired,
  minimumFundingAmount: PropTypes.object.isRequired,
};

export default AddFundErrorMessage;
